/**
 * @param {SelectionState} currentSelection
 * @param {[]Record}       leaves
 */
export default function findSelectionBoundsWithinLeaves(
  currentSelection,
  leaves,
) {
  const anchorOffset = currentSelection.getAnchorOffset();

  const leave = leaves.find(({ start, end }) => {
    if (anchorOffset >= start && anchorOffset <= end) {
      return true;
    }

    return false;
  });

  return leave || null;
}
